import { Component, inject, Input, OnInit } from '@angular/core';

import { MarketplaceKeys } from '@config/keys/shop.keys';
import { LanguageFlagsUrls } from '@config/language-flags.config';

import { SettingsStoreSelector } from '@common/selectors/settings.selector';
import { MarketplaceStoreSelector } from '@common/selectors/marketplace.selector';
import { ChangeLangHandlerService } from '@core/services/i18n/change-lang-handler.service';

@Component({
  selector: 'app-select-language-block',
  templateUrl: './select-language-block.component.html',
  providers: [ChangeLangHandlerService],
  standalone: false,
})
export class SelectLanguageBlockComponent implements OnInit {
  private readonly changeLangService = inject(ChangeLangHandlerService);
  private readonly settingsStoreSelector = inject(SettingsStoreSelector);
  private readonly marketplaceSelector = inject(MarketplaceStoreSelector);

  @Input()
  displayFlag = false;

  locales$ = this.marketplaceSelector.selectMarketplaceLocales;

  selectLanguage!: string;

  languageFlagUrl?: string;

  ngOnInit(): void {
    this.selectLanguage = this.settingsStoreSelector.app.locale;

    if (this.marketplaceSelector.marketplace[MarketplaceKeys.Locales]?.length > 1) {
      this.languageFlagUrl = LanguageFlagsUrls.get(this.settingsStoreSelector.app.locale);
    }
  }

  onChangeLanguage(): void {
    this.changeLangService.changeLang$.next(this.selectLanguage);
  }
}
